export default __webpack_public_path__ + "media/images/gmap_marker-f01e4170de4078af4124cbf545bdda97.png";